/*
 * ============================================================
 * ALPHABET-BUILDER — cart bundle controls
 * ------------------------------------------------------------
 * Loaded on every page via cart-drawer.liquid.
 * Makes a kit behave as ONE item in the cart: removing the kit
 * removes its supplies pack + all 3 letter lines together
 * (matched by the shared hidden `_ab_bundle` line-item property).
 * Search tag: ALPHABET-BUILDER
 * ============================================================
 */
(function () {
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // Count a kit as ONE item: total minus the hidden letter lines
  function adjustedCount(cart) {
    var n = cart.item_count;
    cart.items.forEach(function (it) {
      if (it.properties && it.properties._ab_role === 'letter') n -= it.quantity;
    });
    return n < 0 ? 0 : n;
  }

  function refreshDrawer() {
    // Mirror the theme's own drawer-refresh pattern (jQuery is present site-wide)
    if (window.jQuery) {
      window.jQuery('.drawer').load(document.URL + ' #CartDrawer');
      fetch(root() + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          window.jQuery('.cart-count-bubble span').text(adjustedCount(c));
          if (c.item_count === 0) {
            var cd = document.querySelector('cart-drawer');
            if (cd) cd.classList.add('is-empty');
          }
        });
    } else {
      window.location.reload();
    }
  }

  function removeBundle(bundleId) {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._ab_bundle === bundleId) updates[it.key] = 0;
        });
        if (!Object.keys(updates).length) return null;
        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (res) {
        if (!res) return;
        // On the full cart page, reload so the list updates; in the drawer, refresh the drawer.
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
        } else {
          refreshDrawer();
        }
      })
      .catch(function () { window.location.href = root() + 'cart'; });
  }

  // Delegated click handler so it works after the drawer re-renders
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ab-remove]') : null;
    if (!btn) return;
    e.preventDefault();
    removeBundle(btn.getAttribute('data-ab-remove'));
  });
})();
